
import Vue from "vue";

export default Vue.extend({
  name: "icon-over_content",
  props: {
    image: { type: String, default: "" },
    image2: { type: String, default: null },
    contentBackgroundColor: { type: String, default: "white" },
    xLarge: { type: Boolean, default: false },
    maxwidth: { type: Number, default: 40 },
  },
  computed: {
    isLarge() {
      return !this.xLarge;
    },
    isXLarge() {
      return this.xLarge;
    },
    iconContainerClass(): string {
      let tempClass = "v-btn v-btn--fab v-btn--round primary";

      if (this.xLarge) {
        tempClass = tempClass + " v-size--x-large";
      } else {
        tempClass = tempClass + " v-size--large";
      }
      return tempClass;
    },
  },
});
